exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".restore-route-assignment-css-section .restore-all-btn {\n  padding: 10px 16px !important;\n  font-size: 16px !important;\n  line-height: 1.33333 !important;\n  border-radius: 6px !important; }\n\n.restore-route-assignment-css-section .badge {\n  border-radius: 4px !important;\n  background-color: #5cb85c !important;\n  font-size: 14px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/restore_route_assignments/restore_route_assignments.scss
// module id = 1008
// module chunks = 1